module.exports = __webpack_public_path__ + "static/media/ic_profile.3ae601a8.svg";